import { UpdateInvoiceDto } from "@/core/features/invoice/update-invoice.dto";
import { Expose, Transform } from "class-transformer";
import { toCents } from "@/utils/numberUtils";

export class UpdateCertificationInvoiceDto extends UpdateInvoiceDto {
  @Expose()
  certificationId: string;

  @Expose()
  invoiceId: string;

  @Expose()
  @Transform(({ value }) => (value == null ? value : toCents(value)))
  allocatedAmount?: number;
}
